import Vue from "vue";
import router from '../../router';
import VueSweetalert2 from 'vue-sweetalert2';

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);
export default Vue.extend({
    data: () => ({
        adminEmail: "",
        adminPassword: "",
        adminValid: true,
        adminLoginLoading: false,
        fotp : '',
        fadminPassword : '',
        emailRequired: [
            (v: boolean) => !!v || "Email is required"
        ],
        passwordRequired: [
            (v: boolean) => !!v || "Password is required"
        ],

        fpasswordRequired: [
            (v: boolean) => !!v || "Password is required",
            //@ts-ignore
            (v: boolean) => /^.{8,}$/.test(v) ||  "Password must have at least 8 charecter"
        ],
        otpRequired :[
            v => ( v && v > 0 ) || "Please fill the field.",
        ],
        fogotemailrequired : [
            (v: boolean) => !!v || 'Please choose your register email address'
        ],
        loginsnackbar: false,
        loginErrorMessage: "",
        show2: false,
        step: "step1",
        Data:1,
    }),
    created() {
        const token = localStorage.getItem("jwt");
        console.log("token",token)  
        if (token) {
            router.push("/");
        }
        // else{
        //     router.push("/login");
        // }
    },
    methods: {
        async toggleData(){
            if(this.Data==2){
              this.Data = 1;
            }
            else{
                this.Data = 2;
            }
         },
        async loginAsAdmin() {
            try {
                if (this.$refs.adminLoginForm.validate()) {
                    this.adminLoginLoading = true;
                                       
                    let resp = await this.$http.post('auth/loginByEmail', {
                   // let resp = await Axios.post('http://65.1.59.116/auth/loginByEmail', {
                        'username': this.adminEmail,
                        'password': this.adminPassword,
                    })
                    console.log("resp",resp); 
                    console.log("data",resp.data); 
                    if (resp.status===200) {
                        this.adminLoginLoading = false;
                        if (resp.data.message == 'Login failed, password does not match') {
                            this.alertMsg('Login failed, password does not match.', 'warning', 'Oops!!')
                        } else if (resp.data.message ==="Login successful" && resp.data.user.role_id === 1) {
                            this.alertMsg('You have already used this email id on our super-admin panel.', 'warning', 'Oops!!')
                        } else if (resp.data.message ==="Login successful" && resp.data.user.role_id === 2) {
                            this.alertMsg('You have already used this email id on our student panel.', 'warning', 'Oops!!')
                        } else if (resp.data.message ==="Login successful" && resp.data.user.role_id === 4) {
                            this.alertMsg('You have already used this email id on our admin panel.', 'warning', 'Oops!!')
                        } else {
                            let is_admin = resp.data.user.role_id ;
                            let userToken = resp.data.token; // zreyas token
                            let admin_name = resp.data.user.username;
                            let userId = resp.data.user.user_id;
                            //let adminToken = resp1.data.token; // peekhire token

                            console.log("(is_admin ",resp.data); 
                                                       
                            localStorage.setItem("jwt", userToken);
                            localStorage.setItem("is_admin", is_admin);
                            localStorage.setItem("admin_name", admin_name);
                            localStorage.setItem("userId", userId);

                            //localStorage.setItem("jwt_peek", adminToken);


                            if (localStorage.getItem("jwt") != null) {
                                if (this.$route.params.nextUrl != null) {
                                    this.$router.push(this.$route.params.nextUrl);
                                } else {
                                    if (is_admin === 3) {
                                        const auth = {
                                            headers : {authorization: userToken} 
                                        }
                                        let res = await this.$http.get('/job/fetchRecruiterDetails/'+userId, auth)
                                        console.log("recruiter", res);

                                        if (res.status === 200 && res.data.message === "Recruiter found"){
                                            let account_name = res.data.recruiter.account_name;
                                            let profile_image_url = res.data.recruiter.profile_image_url;
                                            localStorage.setItem("account_name", account_name);
                                            localStorage.setItem("profile_image_url", profile_image_url);
                                            if (res.data.recruiter.name=='N/A' || res.data.recruiter.about=='N/A' || res.data.recruiter.address=='N/A' || res.data.recruiter.category=='N/A'){//|| res.data.recruiter.urls.find(o => o.url_name != 'Company_link')){
                                                this.$router.replace({ name: 'profile_update' })
                                                localStorage.setItem("meassage", 'fromProfile');
                                                
                                            } 
                                            else{
                                                this.$router.push("/");
                                            }        
                                        }
                                    }                                    
                                    else {
                                        this.$router.push({ name: 'login' }).catch(err => { });
                                    }
                                }
                            }
                        }
                    }
                  

                }
            }
            catch (error) {
                console.log('error',error);
                console.log('error',error.response);
                if(error.response.status==409 && error.response.data.message== 'User not registered'){
                    this.loginAsAdmin('Your email-id does not registered.', 'error', 'Oops!!')
                    
                }
                this.adminLoginLoading = false;
            }
        },

        async funcforgotPassword(what) {
            const self = this;
            switch (what) {
                case "step1":
                    if (this.$refs.fogot.validate()) {
                  
                    this.$http.post('/auth/forgotPasswordRecruiter',{
                        username: self.adminEmail.trim(),
                        role_id : 3
                    },{
                        headers: {
                          "Content-Type": "application/json; charset=utf-8",
                        },
                      }
                    )
                    .then(function (response) {
                        if (response.status===200 && response.data.message === "OTP sent"){
                            localStorage.setItem("setEmail", self.adminEmail.trim());
                            self.alertMsg('Otp sent successfully.','success', 'Confirm')
                            self.step = "step2";
                        }                      
                    })
                    .catch((err) => {
                        console.log('result',err.response);
                        
                      // handle error
                        if (err.response.status==401 && err.response.data.message=="User not found"){
                            self.alertMsg('Email-id not registered, enter valid email-id.','error','Oops!!')
                        }
                        else if (err.response.status==408){
                            self.alertMsg('This email-id is being used on our student portal.', 'error', 'Oops!!')
                        }
                    });
                }
                  break;
                case "step2":
                    if (this.$refs.fogot2.validate()) {
                        this.$http.post('/auth/verifyEmailWithOTPForForgotPassword',{
                            username: self.adminEmail.trim(),
                            otp: parseInt(self.fotp),
                            role_id: 3,
                        },
                        {
                            headers: {
                            "Content-Type": "application/json; charset=utf-8",
                            },
                        }
                        )
                        .then((response) => {
                            return this.$http.post('/auth/updatePassword',{
                                username: self.adminEmail.trim(),
                                password: self.fadminPassword.trim(),
                            },
                            {
                                headers: {
                                    "Content-Type": "application/json; charset=utf-8",
                                },
                            });
                        })
                        .then(function (response) {
                        response = response.data;
                        self.adminEmail = '';
                        self.Data=1;
                        self.step = "step1";
                        console.log('self.Data',self.Data);
                        
                        self.alertMsg('Otp verified successfully','success', 'Confirm');
                        
                        })
                        .catch((err) => {
                        // error handling
                        if (err.response.status===400) {
                            self.alertMsg('Incorrect Otp. Please enter correct otp.', 'error', 'Oops!!');
                        }else if (err.response.status=='410') {
                            this.alertMsg('OTP expired, try again.','error', 'Oops!!')
                        }
                        console.log(err);
                        });
                    }
                  break;
                case "step3":
                    console.log(self.adminEmail);
                    this.fotp = '';
                    self.fadminPassword = '';

                    this.$http.post('/auth/forgotPasswordRecruiter',{
                        username: self.adminEmail.trim(),
                        role_id : 3
                    },{
                        headers: {
                          "Content-Type": "application/json; charset=utf-8",
                        },
                      }
                    )
                    .then(function (response) {
                        if (response.status===200 && response.data.message === "OTP sent") {
                            self.alertMsg('Otp sent successfully.','success', 'Confirm')
                        }
                    })
                    .catch((err) => {
                        // handle error
                        console.log("**Error**", err);
                        self.alertMsg('Someting error, re-enter valid email-id.','error','Oops!!')
                    })
                    break;
              }
        },

          alertMsg(message,type,title) {
            this.$swal({
                title: title,
                text: message,
                icon: type,
                confirmButtonText: 'OK',
                customClass: 'swal-title'
            })
        }
    }
});
